export default "__VITE_ASSET__DSPwdqLc__"